<template>
    <v-dialog v-model="modal" :scrim="false" width="900">
        <v-card>
            <cruise-offers :offers="entry.offers" content-class="my-auto" is-package>
                <template v-slot:price="{offer}">
                    <tour-offer-delta-button :offer="offer" :offer-key="offerKey" :entry-name="entry.entryName" />
                </template>
            </cruise-offers>
        </v-card>
        <cruise-info-modal :service-name="entry.name" />
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_CRUISE_INFO} from '@/utils/event-bus'
    import CruiseOffers from '@/components/cruises/search/offers/CruiseOffers.vue'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import CruiseInfoModal from '~src/components/cruises/info/CruiseInfoModal.vue'

    @Component({
        components: {CruiseInfoModal, TourOfferDeltaButton, CruiseOffers},
    })
    export class TourCruiseInfoModal extends Vue {
        @Prop({required: true}) searchRequest

        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_CRUISE_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_CRUISE_INFO, this.showModal)
        }

        showModal({entry, offerKey}) {
            this.entry = entry
            this.offerKey = offerKey
            this.modal = true
        }
    }

    export default TourCruiseInfoModal
</script>
